// import React, { useState } from 'react'
// import { Col, Container, Row } from 'reactstrap'
// import ProjectListNav from './ProjectListNav'
// import ProjectListTabContent from './ProjectListTabContent';
// import Breadcrumbs from '../../../../CommonElements/Breadcrumbs';
// import { ApplicationTitle, ProjectListTitle } from '../../../../Utils/Constants';

// export default function ProjectListContainer() {
//     const [activeTab, setActiveTab] = useState(1);

//     return (
//         <>
//             <Breadcrumbs pageTitle={ProjectListTitle} parent={ApplicationTitle} title={ProjectListTitle} />
//             <Container fluid>
//                 <Row className='project-cards'>
//                     <Col md={12} className="project-list">
//                         <ProjectListNav activeTab={activeTab} setActiveTab={setActiveTab} />
//                     </Col>
//                     <Col sm={12}>
//                         <ProjectListTabContent activeTab={activeTab} />
//                     </Col>
//                 </Row>
//             </Container>
//         </>
//     )
// }

import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import {
  Card, CardBody, Col, Container, FormGroup, Nav, NavItem,
  NavLink, Row, TabContent, TabPane, Progress as ProgressBar
} from 'reactstrap';
import { Link } from 'react-router-dom';
import { PlusSquare, CheckCircle, Info, Target } from 'react-feather';

import Breadcrumbs from '../../../../CommonElements/Breadcrumbs';
import { ApplicationTitle, ProjectListTitle, CreateNewProject, Href } from '../../../../Utils/Constants';
import { RootState } from '../../../../ReduxToolkit/Store';
import { Badges, H5, P, UL, LI, Image } from '../../../../AbstractElements';
import { dynamicImage } from './../../../../Utils'

const projectListNavList = [
  { id: 1, icon: <Target />, text: 'All' },
  { id: 2, icon: <Info />, text: 'Doing' },
  { id: 3, icon: <CheckCircle />, text: 'Done' },
];

function CommonProjectList({ item }: any) {
  return (
    <Col xxl={4} md={6}>
      <div className={`project-box font-dark bg-light-${item.badge === 'Done' ? 'success' : 'danger'}`}>
        <Badges color={item.badge === 'Done' ? 'success' : 'danger'}>{item.badge}</Badges>
        <H5 className={`f-w-500 mb-2 text-${item.badge === 'Done' ? 'success' : 'danger'}`}>{item.title}</H5>
        <div className="d-flex mb-2 align-items-center">
          <Image className='img-20 me-1 rounded-circle' src={dynamicImage(`user/${item.image}`)} alt='' />
          <P className="font-light">{item.sites}</P>
        </div>
        <P>{item.description}</P>
        <Row className='details'>
          <Col xs={6}><span>{'Issues'} </span></Col>
          <Col xs={6} className={`font-${item.badge === 'Done' ? 'success' : 'danger'}`}>{item.issue}</Col>
          <Col xs={6}><span>{'Resolved'}</span></Col>
          <Col xs={6} className={`font-${item.badge === 'Done' ? 'success' : 'danger'}`}>{item.resolved}</Col>
          <Col xs={6}><span>{'Comment'}</span></Col>
          <Col xs={6} className={`font-${item.badge === 'Done' ? 'success' : 'danger'}`}>{item.comment}</Col>
        </Row>
        <div className='customers'>
          <UL className='simple-list flex-row'>
            <LI className='d-inline-block'>
              <Image className='img-30 rounded-circle' src={dynamicImage(`user/${item.customer1}`)} alt='' />
            </LI>
            <LI className='d-inline-block'>
              <Image className='img-30 rounded-circle' src={dynamicImage(`user/${item.customer2}`)} alt='' />
            </LI>
            <LI className='d-inline-block'>
              <Image className='img-30 rounded-circle' src={dynamicImage(`user/${item.customer3}`)} alt='' />
            </LI>
            <LI className='d-inline-block ms-2'>
              <P className='f-12'>{`+${item.like} More`}</P>
            </LI>
          </UL>
        </div>
        <div className='project-status mt-4'>
          <div className="d-flex align-items-center gap-1 mb-2">
            <P className="mb-0">{item.progress}{'%'}</P>
            <span>{'Done'}</span>
          </div>
          <ProgressBar
            style={{ height: "5px" }}
            className={`bg-light-${item.progress === '100' ? 'success' : 'danger'}`}
            color={item.progress === '100' ? 'success' : 'danger'}
            value={item.progress}
            striped
            animated
          />
        </div>
      </div>
    </Col>
  );
}

export default function ProjectListPage() {
  const [activeTab, setActiveTab] = useState(1);
  const projectListData = useSelector((state: RootState) => state.project.items);

  return (
    <>
      <Breadcrumbs pageTitle={ProjectListTitle} parent={ApplicationTitle} title={ProjectListTitle} />
      <Container fluid>
        <Row className='project-cards'>
          {/* Navigation Tabs */}
          <Col md={12} className="project-list">
            <Card>
              <Row>
                <Col md={6}>
                  <Nav className="border-tab" tabs>
                    {projectListNavList.map((item) => (
                      <NavItem key={item.id}>
                        <NavLink
                          href={Href}
                          className={activeTab === item.id ? "active" : ""}
                          onClick={() => setActiveTab(item.id)}
                        >
                          {item.icon}{item.text}
                        </NavLink>
                      </NavItem>
                    ))}
                  </Nav>
                </Col>
                <Col md={6} className='d-md-block d-none'>
                  <FormGroup className="mb-0 me-0">
                    <Link className="btn btn-primary d-flex align-items-center" to={`${process.env.PUBLIC_URL}/project/create_new`}>
                      <PlusSquare /> {CreateNewProject}
                    </Link>
                  </FormGroup>
                </Col>
              </Row>
            </Card>
          </Col>

          {/* Tab Content */}
          <Col sm={12}>
            <Card>
              <CardBody>
                <TabContent activeTab={activeTab}>
                  <TabPane tabId={1}>
                    <Row>
                      {projectListData.map((item, index) => (
                        <CommonProjectList item={item} key={index} />
                      ))}
                    </Row>
                  </TabPane>
                  <TabPane tabId={2}>
                    <Row>
                      {projectListData
                        .filter(item => item.badge === "Doing")
                        .map((item, index) => (
                          <CommonProjectList item={item} key={index} />
                        ))}
                    </Row>
                  </TabPane>
                  <TabPane tabId={3}>
                    <Row>
                      {projectListData
                        .filter(item => item.badge === "Done")
                        .map((item, index) => (
                          <CommonProjectList item={item} key={index} />
                        ))}
                    </Row>
                  </TabPane>
                </TabContent>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </>
  );
}
